import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=7c70199e&scoped=true&"
import script from "./ReportsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=7c70199e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70199e",
  null
  
)

export default component.exports